import { useMutation, useQueryClient } from "@tanstack/react-query";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import patchTaskV3 from "../requests/patchTask.v3";
import { taskUrl } from "../requests/urls";
import { refetchActivityLogWithDelay } from "../utils/refetchActivityLog";
import { tasksKeyMakerV3 } from "./useGetTasks.v3";
const idemDescriptor = "patch-task";
export default function useUpdateTaskV3(config) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async ({ taskId, request, queryParams }) => {
            if (config === null) {
                throw new Error("No auth config");
            }
            return patchTaskV3(taskId, request, 
            // NOTE: generate new idempotency key on each request, we are not using retry mechanism here so we don't need to keep the same key
            genIdempotencyKey(idemDescriptor), config, queryParams);
        },
        onSuccess: (task, { parentTaskId }) => {
            // NOTE: invalidate all cached paginated tasks queries
            queryClient.invalidateQueries({ queryKey: tasksKeyMakerV3(null) });
            // NOTE: invalidate modified task
            queryClient.invalidateQueries({ queryKey: [taskUrl("v3", task.id)] });
            // NOTE: refetch activity log
            refetchActivityLogWithDelay(task.id, queryClient);
            if (parentTaskId) {
                // NOTE: invalidate parent task
                queryClient.invalidateQueries({
                    queryKey: [taskUrl("v3", parentTaskId)],
                });
            }
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=useUpdateTask.v3.js.map